[
    { "displayedName": "Axione", "name": "axione", "type": "National" },
    { "displayedName": "Bouygues Telecom", "name": "bouygues_telecom", "type": "National" },
    { "displayedName": "Covage", "name": "covage", "type": "National" },
    { "displayedName": "Eurofiber", "name": "eurofiber", "type": "National" },
    { "displayedName": "Free", "name": "free", "type": "National" },
    { "displayedName": "Ielo", "name": "ielo_liazo", "type": "National" },
    { "displayedName": "Lumière", "name": "lumiere", "type": "National" },
    { "displayedName": "Orange", "name": "orange", "type": "National" },
    { "displayedName": "RATP Connect", "name": "ratp_connect", "type": "Régional" },
    { "displayedName": "SFR", "name": "sfr", "type": "National" }
]